import React from 'react';
import { useParams } from 'react-router-dom';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import NotFound from '../../../features/NotFound/NotFoundPage';
import PageTitle from '../../../utils/PageTitle';
import { GetSearchParams } from '../../../utils/URL';
import AdminsListProvider from '../AdminList/AdminsListProvider';
import AddressCont from './Address/AddressCont';
import AdminInfoProvider, { useAdminInfo } from './AdminInfoProvider';
import AdminInfo from './Components/AdminInfo';
import AdminInfoStatus from './Components/AdminInfoStatus';
import AdminInfoTabs from './Components/AdminInfoTabs';
import PermissionTable from './Components/TabTablePages/Permissions/PermissionTable';

function TabComponentRender({ data, permissions, loading }) {
    const tabName = GetSearchParams('tab') || 'permissions';

    switch (tabName) {
        case 'permissions':
            return <PermissionTable data={data} permissions={permissions} pageLoading={loading} />;

        default:
            return null;
    }
}

function PageCont() {
    const { adminInfoData, handleReload, handleShowNewSubScription, loading } = useAdminInfo();

    PageTitle(
        `${adminInfoData.organization ? adminInfoData.organization : adminInfoData.fullName} `
    );

    if (adminInfoData && Object.keys(adminInfoData).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="Not Found!"
                    btnTitle="Back to list"
                    path="/settings/admins"
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="customers_details_page inner_page_cont">
            {/* <CustomersDetailsHeader /> */}
            <AdminInfo data={adminInfoData} handleReload={handleReload} />
            <AdminInfoStatus data={adminInfoData} />
            {/* Address Modal */}
            <AddressCont addressData={adminInfoData?.addresses} />

            <div className="customers_details_body">
                <LayoutProvider>
                    <AdminInfoTabs
                        data={adminInfoData}
                        handleShowNewSubScription={handleShowNewSubScription}
                        layout="default"
                    />
                </LayoutProvider>
                <TabComponentRender
                    data={adminInfoData}
                    loading={loading}
                    permissions={adminInfoData.permissions}
                />
            </div>
        </div>
    );
}

function AdminInfoPage() {
    const { userID } = useParams();

    return (
        <AdminsListProvider>
            <AdminInfoProvider id={userID}>
                <PageCont />
            </AdminInfoProvider>
        </AdminsListProvider>
    );
}

export default AdminInfoPage;
